import { Form, Input } from "antd";

export default function RenderInput(props) {
	const { namePath = [], required = false, inputType = "text" } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Form.Item
			name={newNamePath}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<Input placeholder="Answer" size="large" type={inputType} />
		</Form.Item>
	);
}
